<template>


  <div class="flex flex-col justify-center items-center">

    <div v-if="loading">
        
            <ring-loader ></ring-loader> 
        </div>

      <div class="flex-col justify-center content-center items-baseline mt-4 lg:mt-10">

            <img class="rounded-full p-4 lg:p-8 object-cover bg-white h-32 w-32 lg:h-64 lg:w-64" src="@/assets/images/full-logo.jpg">
        </div>

      <div class="mt-8 lg:mt-20 p-5 lg:p-10 bg-blue-300 rounded-full border-blue-800 border-4">
        
        <label>{{$t('payment.successfulPayment')}}</label>  
      </div>
  </div>
</template>

<script>

// import axios from '@/classes/myAxios'
import axios from '@/classes/myAxios'


import { RingLoader } from 'vue-spinners-css';

import componentsHelpers from '../classes/componentHelpers';

import authHttpHelper from '../auth/auth-http-helper';

export default {

  async mounted(){

    // console.log(`in successfulpayment`);
    const route = this.$route;

      // console.log(`query ${JSON.stringify(route)}`);

    // console.log(`query ${JSON.stringify(route.query)}`);

    try{
      
      // console.log(`typeof ${typeof route.query.txnId}`);

      // console.log(`value: ${ route.query.txnId}`);

      // https://pnadi.com/successfulPayment?txnId=8081161616863084&merchantTxnId=20800001588380527222

      // console.log(`route.query.txnId: ${ route.query.txnId}`);

      // console.log(`route.query.merchantTxnId: ${ route.query.merchantTxnId}`);

      // console.log(`route.query.txnId != '' && route.query.txnId != null :${route.query.txnId != ''} && ${route.query.txnId != null}`);

     if(route.query.txnId != '' && route.query.txnId != null){

      // console.log(`inside and before payment verification`)

       const paymentResult = await axios({method: 'post',
            
        url: '/pnadiapi/payment/verifyAndSavePayment',

        data: {
        
        key: authHttpHelper.getKey(),
        txnId: route.query.txnId,
        merchantTxnId: route.query.merchantTxnId,
        }});

        // console.log(`paymentResult: ${JSON.stringify(paymentResult)}`);

        if(paymentResult.status == 200){

        componentsHelpers.toastIt(this.$toasted,
         this.$t('payment.transactionVerifiedToast'), 2,
         'bubble', true);

          const router = this.$router;
          setTimeout(function(){

            router.replace({ path: '/packages', query: { redirected: 'false' }});
          }, 10000);
        }
     }
    }catch(error){

        componentsHelpers.sendError(this.$apollo, 0,'PaymentLayout', 'successfulPayment', 'mounted-try-axios', error);

        componentsHelpers.toastIt(this.$toasted,
         this.$t('payment.paymentError'), 3,
         'bubble', true);
    }


  },

  components:{

    RingLoader
  }
}
</script>

<style>

</style>